import { keyframes } from 'styled-components';

const blink = keyframes`
  0% {
    opacity: 1;
  }

  50% {
    opacity: .4;
  }

  100% {
    opacity: 1;
  }
`;

export { blink };



// WEBPACK FOOTER //
// ./src/utils/animations.js